import { Injectable, Input, Output, EventEmitter, Directive, OnInit } from '@angular/core';
import { UntypedFormGroup, AbstractControl } from '@angular/forms';


@Directive()
@Injectable()
export class FormBase<T> implements OnInit {

    @Input() readonly: boolean;

    @Output() onSave: EventEmitter<T> = new EventEmitter<T>();
    @Output() onCancel: EventEmitter<void> = new EventEmitter<void>();

    @Input() saveTitle = 'Guardar';
    @Input() cancelTitle = 'Cancelar';

    @Input() touched = true;

    constructor() {
    }

    ngOnInit(): void {
    }

    public onCancelEvent(): void {

        this.onCancel.emit();
    }

    protected _formGet(form: AbstractControl, propName: string): AbstractControl | null {

        return form ? form.get(propName) : null;
    }

    protected _isInvalid(form: AbstractControl, propName: string, touched: boolean = this.touched): boolean {

        if (!form) {
            return true;
        }

        if (this.readonly) {
            return false;
        }

        const prop = form.get(propName);
        let invalid = prop && prop.invalid;
        if (touched) {
            invalid = invalid && prop.touched;
        }
        return invalid;
    }

    protected _changeReadonly(form: UntypedFormGroup): void {

        for (const key in form.controls) {

            if (this.readonly) {
                form.controls[key].disable();
            } else {
                form.controls[key].enable();
            }
        }
    }

    protected _toModel(form: UntypedFormGroup): any {

        if (form) {

            const model = {};
            for (const key in form.controls) {

                if (form.controls.hasOwnProperty(key)) {
                    const element = form.controls[key];
                    model[key] = element.value;
                }
            }
            return model;
        }
        return null;
    }

    protected _randomNumber(min: number, max: number): number {
        // min and max included
        return Math.floor(Math.random() * (max - min + 1) + min);
    }
}
